<span [innerHTML]="getSymbol()"></span>
